class NumberInput {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-input="scope"]',
			counter: '[data-input="counter"]',
			minusBtn: '.btn-minus',
			plusBtn: '.btn-plus',
			input: 'input',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		$(document).off('.number-input')
			.on('click.number-input', this.config.minusBtn, this.changeAmount.bind(this))
			.on('click.number-input', this.config.plusBtn, this.changeAmount.bind(this));
	}

	changeAmount(e) {
		e.preventDefault();
		let $target = $(e.currentTarget);
		let $scope = $target.closest(this.config.scope);

		let isNegative = $target.is(this.config.minusBtn);
		let $input = $scope.find(this.config.input);

		if ($input.is('input')) {
			$input[0][isNegative ? 'stepDown' : 'stepUp']();
			$input.trigger('change');
		}
	}
}

export default new NumberInput;
